var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrapperResourceSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "380px",
    height: "234px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PSgrad_0",
    x1: "0%",
    x2: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgb(73, 90, 104)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgb(13,22,37)",
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(14, 42, 77)",
    d: "M48.806,184.120 L48.806,54.285 L54.437,48.653 L348.836,48.946 L355.719,57.706 L355.719,182.565 L262.485,182.565 L249.970,175.056 L142.344,175.056 L128.578,183.816 L48.806,184.120 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "1px",
    stroke: "rgb(165, 165, 165)",
    fill: "url(#PSgrad_0)",
    d: "M48.806,184.120 L48.806,54.285 L54.437,48.653 L348.836,48.946 L355.719,57.706 L355.719,182.565 L262.485,182.565 L249.970,175.056 L142.344,175.056 L128.578,183.816 L48.806,184.120 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapperResourceSelected);
export default __webpack_public_path__ + "static/media/wrapperResourceSelected.6c520bba178357a8db8188b858534add.svg";
export { ForwardRef as ReactComponent };